import { inventoryTransformer } from './inventory';
import DEFAULT from './constants';
const getTransformedData = (data, isDesktop, store = DEFAULT.STORE, pagePrefix = DEFAULT.PAGE_PREFIX, offset = 0, previewMode = false) => {
    if (!data || data.length < 1) {
        return [];
    }
    const transformedData = data.map((item) => inventoryTransformer(item, isDesktop, store, pagePrefix, offset, previewMode));
    return { widgets: transformedData, styles: {} };
};
export default getTransformedData;
